export default ['api', 'availabilityApiService', function (api, availabilityApiService) {
    return {
        find: (date, eventType, eventId) => {
            return api.get(`${availabilityApiService.switchEventType(eventType)}/${eventId}/start-times?date=${date}`).
                then(response => {
                    if (!response.data.length){
                        availabilityApiService.uncacheDate(eventType, eventId, date);
                        return false;
                    }
                    return response.data;
                });
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/availability/services/startTime.api.service.js